import loadModuleOnElement from "../../utils/loadModuleOnElement";

const moduleLoader = () => import("./section");

export default function loader(context) {
    loadModuleOnElement(".live-section-update", moduleLoader, context);
    return context;
}
